import { render, staticRenderFns } from "./selectProvince.vue?vue&type=template&id=55d0099a&"
import script from "./selectProvince.vue?vue&type=script&lang=js&"
export * from "./selectProvince.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports